import { useMemo } from "react";
import { MRT_ColumnDef } from "material-react-table";
import MATERIAL_TABLE_CONTAINER from "../../../../main_components/material_table/table_container";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

export default function EXTRA_INVOICE_DETAILS(props: any) {

    const columns: MRT_ColumnDef<any>[] = useMemo(
        () => [

            {
                header: "Código",
                accessorKey: "code",
                id: "code",
                size: 120,
            },
            {
                header: "Descripción",
                accessorKey: "description",
                id: "description",
                size: 300,
            },
            {
                header: "Cantidad",
                accessorKey: "quantity",
                id: "quantity",
            },
            {
                header: "Precio",
                accessorKey: "price",
                id: "price",
            },
            {
                header: "Total",
                accessorKey: "total",
                id: "total",
            }
        ],

        [props?.detaills]
    );



    return (
        <div>

            

            <MATERIAL_TABLE_CONTAINER
                key={"INVOICE_UP_LOADER_TS"}
                columns={columns}
                data={props?.detaills}
                breadcrumbs={props?.breadcrumbs ? [{ label: "ORDENES DE COMPRA DISPONIBLES", path: null }] : null}
                modalT={false}
                isLoading={false}
                search_filters={<div></div>
                }
                component_header={
                    <div></div>
                }
                file_name_export="FACTURAS"
                update_identifiers={[]}
            ></MATERIAL_TABLE_CONTAINER>

        </div >
    );
}
